import { types } from 'mobx-state-tree';
import ResourceSubjectPermission from './ResourceSubjectPermission';
var ResourceSubjectPermissionCollection = types.model({
    levelIndex: types.number,
    pathIndex: types.number,
    resourceSubjectPermissions: types.array(ResourceSubjectPermission)
})
    .named('ResourceSubjectPermissionCollection')
    .views(function (self) { return ({
    getResourceSubjectPermission: function (resourceId) {
        return self.resourceSubjectPermissions.find(function (x) { return x.resourceId === resourceId; });
    },
    addResourceSubjectPermission: function (resourceId, permissions) {
        self.resourceSubjectPermissions.push(ResourceSubjectPermission.create({
            resourceId: resourceId,
            permissions: permissions
        }));
    }
}); });
export default ResourceSubjectPermissionCollection;
//# sourceMappingURL=ResourceSubjectPermissionCollection.js.map